import { Component, OnInit, ViewChild, inject } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators} from '@angular/forms';
import {
  ButtonSize,
  ButtonState,
  ButtonType,
  IJobOffer,
  InputSize,
  InputState,
} from '../../../../../assets/types/dtoTypes';
import { JobService } from './create-job-offer.service';
import { BreakpointsService, BIPPERZ_BREAKPOINTS } from '../../../../shared/services/breakpoint.service';
import {
  SALARY_RANGES,
  GERMAN_LEVELS,
  EXPERIENCES,
  EDUCATION_LEVELS,
  PATH,
} from '../../../../../assets/constants';
import {MatError } from '@angular/material/select';
import {MatChipListbox} from '@angular/material/chips';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { PopupComponent } from '../../../../shared/popup/popup.component';
import { JobPageService } from '../jobs-page/jobs-page.service';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import {ExternalHeaderComponent} from "../../../../shared/external-header/external-header.component";
import {InputComponent} from "../../../../shared/input/input.component";
import {MatDivider} from "@angular/material/divider";
import {AppInputAreaComponent} from "../../../../shared/text-areas/app-input-area.component";
import {ButtonComponent} from "../../../../shared/button/button.component";
import {NgClass, NgIf} from "@angular/common";
import {LoadMaskComponent} from "../../../../shared/load-mask/load-mask.component";
import {DropdownComponent} from "../../../../shared/countries-dropdown/dropdown.component";
import {FooterComponent} from "../../../../shared/footer/footer.component";


@Component({
  selector: 'app-jobs-create',
  templateUrl: './create-job-offer.component.html',
  styleUrls: ['./create-job-offer.component.scss'],
  imports: [
    ExternalHeaderComponent,
    TranslateModule,
    InputComponent,
    ReactiveFormsModule,
    MatError,
    FormsModule,
    MatDivider,
    AppInputAreaComponent,
    ButtonComponent,
    NgIf,
    LoadMaskComponent,
    DropdownComponent,
    NgClass,
    FooterComponent
  ],
  standalone: true
})
export class JobOfferCreateComponent implements OnInit {
  private jobService = inject(JobService);
  private jobPageService = inject(JobPageService);
  private breakpointsService = inject(BreakpointsService);
  private route = inject(ActivatedRoute);
  private dialog = inject(MatDialog);
  private router = inject(Router);
  private translateService = inject(TranslateService);
  salaryRangeCtrl     = new FormControl<string | null>(null);
  languageLevelCtrl   = new FormControl<string | null>(null);
  experienceCtrl      = new FormControl<string | null>(null);
  educationCtrl       = new FormControl<string | null>(null);

  isMobile = false;

  isLoading = false;

  today: string = new Date().toISOString().split( 'T' )[0];

  job: Partial<IJobOffer> = this.initEmptyJob();

  @ViewChild( 'certChipList' ) certChipList!: MatChipListbox;

  skillCtrl = new FormControl();

  form!: FormGroup;

  titleFormControl: FormControl = new FormControl( '', Validators.required );

  descriptionFormControl: FormControl = new FormControl( '', Validators.required );

  qualificationsFormControl: FormControl = new FormControl( '', Validators.required );

  locationFormControl: FormControl = new FormControl( '', Validators.required );

  endDateFormControl: FormControl = new FormControl( '', Validators.required );

  companyId: string = '';

  salaryRanges = SALARY_RANGES.map( item => item.label );

  germanLevels = GERMAN_LEVELS.map( item => item.label );

  experiences = EXPERIENCES.map( item => item.label );

  educationLevels = EDUCATION_LEVELS.map( item => item.label );

  protected readonly String = String;

  protected readonly InputState = InputState;

  protected readonly InputSize = InputSize;

  protected readonly ButtonSize = ButtonSize;

  protected readonly ButtonState = ButtonState;

  protected readonly ButtonType = ButtonType;

  isEditMode = false;

  jobId: string;

  constructor() {
    this.breakpointsService
      .observe( [ BIPPERZ_BREAKPOINTS.s, BIPPERZ_BREAKPOINTS.m_down ] )
      .subscribe( ( result ) => {
        this.isMobile = result.s || result.m_down;
      } );
  }

  private initEmptyJob(): Partial<IJobOffer> {
    return {
      id: '',
      companyName: '',
      companyLogoUrl: '',
      createdAt: '',
      companyId: this.companyId,
      title: '',
      description: '',
      qualifications: '',
      location: '',
      industry: '',
      workingHours: '',
      startDate: '',
      duration: '',
      salaryRange: '',
      housingSupport: false,
      languageLevel: '',
      experience: '',
      education: '',
      tags: [],
      profilesCount: 1,
      endDate: '',
    };
  }

  ngOnInit(): void {
    this.companyId = this.route.snapshot.paramMap.get( 'companyId' )!;

    this.route.queryParams.subscribe( params => {
      const isEdit = params.edit === 'true';
      this.jobId = params.jobId;

      if ( isEdit && this.jobId ) {
        this.isEditMode = true;
        this.jobService.getJobOffer( this.jobId ).subscribe( job => {
          this.prefillFormFromJob( job );
        } );
      } else {
        this.job = this.initEmptyJob();
        this.job.companyId = this.companyId;
      }
    } );
    this.salaryRangeCtrl.valueChanges.subscribe(v   => this.job.salaryRange  = v ?? '');
    this.languageLevelCtrl.valueChanges.subscribe(v => this.job.languageLevel = v ?? '');
    this.experienceCtrl.valueChanges.subscribe(v    => this.job.experience   = v ?? '');
    this.educationCtrl.valueChanges.subscribe(v     => this.job.education    = v ?? '');

  }

  onDescriptionChange( text: string ): void {
    this.descriptionFormControl.setValue( text );
  }


  onQualificationsChange(text: string): void {
    this.qualificationsFormControl.setValue(text);
    this.job.qualifications = text;
  }

  private prefillFormFromJob(job: IJobOffer): void {
    this.job = {
      id: job.id,
      companyName: job.companyName,
      companyLogoUrl: job.companyLogoUrl,
      createdAt: job.createdAt,
      companyId: job.companyId,
      title: job.title || '',
      description: job.description || '',
      qualifications: job.qualifications || '',
      location: job.location || '',
      industry: job.industry || '',
      workingHours: job.workingHours || '',
      startDate: job.startDate || '',
      duration: job.duration || '',
      salaryRange: job.salaryRange || '',
      housingSupport: job.housingSupport || false,
      languageLevel: job.languageLevel || '',
      experience: job.experience || '',
      education: job.education || '',
      tags: job.tags || [],
      profilesCount: job.profilesCount || 1,
      endDate: job.endDate || '',
    };

    this.titleFormControl.setValue(this.job.title, { emitEvent: false });
    this.descriptionFormControl.setValue(this.job.description, { emitEvent: false });
    this.qualificationsFormControl.setValue(this.job.qualifications, { emitEvent: false });
    this.locationFormControl.setValue(this.job.location, { emitEvent: false });
    this.endDateFormControl.setValue(this.job.endDate, { emitEvent: false });

    this.salaryRangeCtrl.setValue(this.job.salaryRange || null, { emitEvent: false });
    this.languageLevelCtrl.setValue(this.job.languageLevel || null, { emitEvent: false });
    this.experienceCtrl.setValue(this.job.experience || null, { emitEvent: false });
    this.educationCtrl.setValue(this.job.education || null, { emitEvent: false });

    this.skillCtrl.setValue(this.job.tags, { emitEvent: false });
  }

  isInvalidAndTouched( control: FormControl ): boolean {
    return control.invalid && ( control.dirty || control.touched );
  }

  submitJobOffer(): void {

    this.isLoading = true;
    this.job.title = this.titleFormControl.value;
    this.job.description = this.descriptionFormControl.value;
    this.job.qualifications = this.qualificationsFormControl.value;
    this.job.location = this.locationFormControl.value;
    this.job.endDate = this.endDateFormControl.value;
    this.job.tags = [...this.job.tags];

    if ( !this.isEditMode ) {
      this.jobService.createJobOffer( this.job ).subscribe( {
        next: ( ) => {
          this.isLoading = false;
          const dialogRef = this.dialog.open( PopupComponent, {
            width: '400px',
            data: {
              title: this.translateService.instant( 'job_details.successJobOffer.title' ),
              message: this.translateService.instant( 'job_details.successJobOffer.created' ),
              isSuccess: true,
            },
          } );
          dialogRef.afterClosed().subscribe( () => {
            this.router.navigate( [ `${PATH.COMPANY_DASHBOARD}/${this.companyId}` ] );
          } );
        },      error: ( error ) => console.error( 'Submit failed:', error ),
      } );
    } else {
      this.jobPageService.editJobOffer( this.jobId, this.job ).subscribe( {
        next: () => {
          this.isLoading = false;
          const dialogRef = this.dialog.open( PopupComponent, {
            width: '400px',
            data: {
              title: this.translateService.instant( 'job_details.successJobOffer.title' ),
              message: this.translateService.instant( 'job_details.successJobOffer.edited' ),
              isSuccess: true,
            },
          } );
          dialogRef.afterClosed().subscribe( () => {
            this.router.navigate( [ `${PATH.COMPANY_DASHBOARD}/${this.companyId}` ] );
          } );
        },      error: ( error ) => console.error( 'Submit failed:', error ),
      } );
    }


  }

  isSubmitDisabled(): boolean {
    return this.titleFormControl.invalid ||
      this.descriptionFormControl.invalid ||
      this.qualificationsFormControl.invalid ||
      this.locationFormControl.invalid
  }


}
